'use client';

import { useBrowserScreenshotArtifact } from '../hooks/useBrowserScreenshotArtifact';
import { useBrowserScreenshotUrl } from '../hooks/useBrowserScreenshotUrl';
import { BrowserSnapshotScreenshot } from './BrowserSnapshotScreenshot';

type BrowserToolCallScreenshotProps = {
  toolCallId: string;
  showLabel?: boolean;
  watch?: boolean;
};

export function BrowserToolCallScreenshot({
  toolCallId,
  showLabel = true,
  watch = false,
}: BrowserToolCallScreenshotProps) {
  const artifact = useBrowserScreenshotArtifact(toolCallId, { watch });
  const { screenshotUrl } = useBrowserScreenshotUrl(artifact?.id);

  return screenshotUrl ? (
    <BrowserSnapshotScreenshot
      url={screenshotUrl.signedUrl}
      showLabel={showLabel}
    />
  ) : null;
}
